module.exports = __webpack_public_path__ + "img/dashboard_market.9cfdb5a.png";